import { linklistApi } from '@/utils/axios-config';

export default {
    me() {
        return linklistApi.get(`/users/me/`);
    },
    requestPasswordReset(email) {
        return linklistApi.post(`/users/request-password-reset`, {
            email,
        });
    },
    resetPassword(email, token, password) {
        return linklistApi.post(`/users/reset-password`, {
            email: email,
            token: token,
            password: password,
        });
    },
    register(data) {
        return linklistApi.post(`/users/register`, data);
    },
};
